<template>
  <div
    :class="$style.sbFilterBar"
    data-sb-regression="sb-filter-bar"
    data-sb-automation="sb-filter-bar-next"
  >
    <div :class="$style.filters">
      <div :class="[$style.searchFilterBar]">
        <slot name="search">
          <sb-filter-search
            version="next"
            :placeholder="searchPlaceholder"
            data-sb-automation="sb-filter-search-next"
            :min-search-term-length="3"
            @search="emit('search', $event)"
          />
        </slot>
      </div>
      <div>
        <slot name="filters">
          <sb-filter-options
            :column-definitions="columnDefinitions"
            :filters="filters"
            data-sb-automation="sb-filter-options-next"
            :initial-values="{ savedColumns: appliedColumns, savedFilters: appliedFilters }"
            @change-filter-selection="emit('update:applied-filters', $event)"
            @change-column-selection="emit('update:applied-columns', $event)"
          >
            <template #options>
              <slot name="options" />
            </template>
          </sb-filter-options>
        </slot>
      </div>
    </div>
    <div
      v-if="hasFilters"
      :class="$style.chips"
    >
      <slot name="chips">
        <sb-filter-chips
          version="next"
          data-sb-automation="sb-filter-chips-next"
          :filters="filters"
          :applied-filters="appliedFilters"
          @removed-filter="emit('removed-filter', $event)"
        />
      </slot>
    </div>
  </div>
</template>

<script setup>
import { defineOptions, defineProps, defineEmits, computed } from 'vue';
import SbFilterSearch from '@src/components/Filter/components/SbFilterSearch.vue';
import SbFilterOptions from '@src/components/Filter/next/components/SbFilterOptions.vue';
import SbFilterChips from '@src/components/Filter/SbFilterChips.vue';

defineOptions({
  name: 'SbFilterBarNext',
});

const props = defineProps({
  placeholder: {
    type: String,
    default: 'Enter your search',
  },
  columnDefinitions: {
    type: Array,
    required: true,
  },
  filters: {
    type: Array,
    required: true,
  },
  appliedFilters: {
    type: Object,
    required: true,
  },
  appliedColumns: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['update:applied-filters', 'update:applied-columns', 'search', 'removed-filter']);

const hasFilters = computed(() => {
  return Object.keys(props.appliedFilters).length > 0;
});
</script>

<style lang='scss' module>
@use '@src/components/Filter/next/styles/sbFilterBar.module.scss';
</style>
